// extracted by mini-css-extract-plugin
export var container = "_75-0";
export var fallback = "_75-5";
export var fallbackIcon = "_75-6";
export var hidden = "_75-2";
export var image = "_75-3";
export var loaded = "_75-4";
export var placeholder = "_75-1";